import React from 'react';
import { Button } from '../ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const Pagination = ({ 
  pagination, 
  onPageChange,
  language = 'es'
}) => {
  const { page, total_pages, has_prev, has_next, total } = pagination;
  
  const t = {
    es: { page: 'Página', of: 'de', total: 'Total' },
    en: { page: 'Page', of: 'of', total: 'Total' }
  };
  
  const texts = t[language] || t.es;
  
  if (total_pages <= 1) return null;
  
  return (
    <div className="flex items-center justify-between mt-4 px-2">
      <span className="text-sm text-muted-foreground">
        {texts.total}: {total?.toLocaleString()}
      </span>
      <div className="flex items-center gap-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(page - 1)}
          disabled={!has_prev}
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <span className="text-sm text-muted-foreground min-w-[100px] text-center">
          {texts.page} {page} {texts.of} {total_pages}
        </span>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(page + 1)}
          disabled={!has_next}
        >
          <ChevronRight className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default Pagination;
